import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  Pagination,
  Modal,
  Button,
} from "react-bootstrap";
import {
  GetRiderlocationPost,
  getallrider,
  GetRiderDistance,
  getallriderAkira,
  GetRiderDistanceAkira,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import LoadingSpinner from "views/Components/loadingSpinner";
import Datetime from "react-datetime";
import NotificationSystem from "react-notification-system";
import Card from "components/Card/Card.jsx";
import { style } from "../../../variables/Variables";
import Select from "react-select";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import moment from "moment";

export class RiderDistance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from_date: "",
      rider_details: [],
      selected_rider: null,
      selected_riderError: null,
      selected_riderDateError: null,
      loading: false,
      noRecordFound: true,
      _notificationSystem: null,
      rider_data: [],
      locationdetails: [],
      bounds_data: null,
      finallat: parseFloat(0),
      finallng: parseFloat(0),
      locationmodal: false,
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      currentLocation: null,
      isDispatch: false,
      page: 1,
    };
    this.handlesearch = this.handlesearch.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
  }

  handlefromdate = (date) => {
    this.setState({ 
      from_date: date,
      selected_riderDateError: null,
     });
  };

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5,
    });
  }

  openlocation(lati, long, type) {
    this.setState({
      locationmodal: true,
      currentLocation: { long: long, lati: lati },
      isDispatch: type,
    });

    var points_data = [{ lat: parseFloat(lati), lng: parseFloat(long) }];
    this.setState({ finallat: parseFloat(lati), finallng: parseFloat(long) });

    var bounds = new this.props.google.maps.LatLngBounds();
    for (var i = 0; i < points_data.length; i++) {
      console.log("hi", points_data[i]);
      bounds.extend(points_data[i]);
    }
    console.log(bounds, "bonds");
    this.setState({ bounds_data: bounds });
  }

  closelocationmodal() {
    this.setState({ locationmodal: false, bounds_data: null });
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    let role = 5;
    // getallrider("", role, obj)
    //   .then((res) => {
    //     const data = res.data;

    //     var array1 = this.state.rider_details;
    //     var array2 = array1.concat(data);

    //     this.setState({
    //       rider_details: array2,
    //     });

    //     let riderItems = [];
    //     this.state.rider_details.map((x, i) => {
    //       riderItems.push({ value: x.id, label: x.name });
    //     });
    //     this.setState({
    //       rider_data: riderItems,
    //     });
    //   })
    //   .catch(() => {
    //     this.handleNetworkError("bl");
    //   });
    getallriderAkira("", role, obj)
      .then((res) => {
        const data = res;

        var array1 = this.state.rider_details;
        var array2 = array1.concat(data);

        this.setState({
          rider_details: array2,
        });

        let riderItems = [];
        this.state.rider_details.map((x, i) => {
          riderItems.push({ value: x.id, label: x.userName });
        });
        this.setState({
          rider_data: riderItems,
        });
      })
      .catch(() => {
        this.handleNetworkError("bl");
      });
  }

  paginationinfo(url) {
    this.setState({ page: url });
    console.log(url);
    setTimeout(() => this.handlesearch(), 400);
  }

  handlesearch() {
    this.setState({ noRecordFound: false });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ 
      selected_riderError: null, 
      selected_riderDateError: null, 
    });
    var error = false;

    if (this.state.selected_rider == null || this.state.selected_rider == "") {
      error = true;
      this.setState({
        selected_riderError: (
          <small className="text-danger">Please Select Rider</small>
        ),
      });
    } else {
      this.setState({ selected_riderError: null });
    }
    if (this.state.from_date == null || this.state.from_date == "") {
      error = true;
      this.setState({
        selected_riderDateError: (
          <small className="text-danger">Please Select Date</small>
        ),
      });
    } else {
      this.setState({ selected_riderDateError: null });
    }

    if (!error) {
      this.setState({ loading: true }, () => {
        var from_date = "";

        if (this.state.from_date != "" && this.state.from_date != null) {
          from_date = moment(this.state.from_date).format("YYYY-MM-DD");
          if (from_date == "Invalid date") {
            from_date = "";
          }
        }

        console.log(
          this.state.selected_rider.value,
          this.state.page,
          from_date
        );

        GetRiderDistanceAkira(
          this.state.selected_rider.value,
          this.state.page,
          from_date,
          obj
        ).then((res) => {
          console.log(res.distanceForOrders)
          var data = res.distanceForOrders;
          if (data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("?page=") + 1
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("?page=") + 1
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          console.log(res);
          this.setState({
            locationdetails: res.distanceForOrders,
            paginationData: $no_pages,
            loading: false,
          });
        });
      });
    }
  }

  resetSearch() {
    this.setState({
      from_date: "",
      noRecordFound: true,
      locationdetails: [],
      selected_rider: "",
    });
  }

  render() {
    var c = 1;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                content={
                  <Row>
                    <Col className="consultation_filter_container">
                      <Row>
                        <Col md={3}>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            placeholder="Rider"
                            name="selected_rider"
                            value={this.state.selected_rider}
                            onChange={(value) =>
                              this.setState({
                                selected_rider: value,
                                selected_riderError: "",
                              })
                            }
                            options={this.state.rider_data}
                          />
                          {this.state.selected_riderError}
                        </Col>
                        <Col md={3}>
                          <Datetime
                            className="filter_FormTodate"
                            timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: "Select Date" }}
                            closeOnSelect={true}
                            value={this.state.from_date}
                            onChange={this.handlefromdate}
                            />
                          {this.state.selected_riderDateError}
                        </Col>
                        <Col md={5}>
                          <Button
                            bsStyle="info"
                            fill
                            onClick={this.handlesearch}
                          >
                            Search
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            class="btn-color"
                            fill
                            onClick={this.resetSearch.bind(this)}
                          >
                            Reset
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Order Id</th>
                            <th>Dispatched Location</th>
                            <th>Completed Location</th>
                            <th>Total Distance (Km)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="6">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="6">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {this.state.locationdetails.map((s) => (
                                <tr>
                                  <td>{s.orderId}</td>
                                  <td>
                                    {s.dispatchedLocation  ? (
                                      <i
                                        style={{ cursor: "pointer" }}
                                        className="fa fa-map-marker"
                                        onClick={this.openlocation.bind(
                                          this,
                                          s.dispatchedLocation.latitude,
                                          s.dispatchedLocation.longitude,
                                          true
                                        )}
                                      ></i>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {s.completedLocation ? (
                                      <i
                                        style={{ cursor: "pointer" }}
                                        className="fa fa-map-marker"
                                        onClick={this.openlocation.bind(
                                          this,
                                          s.completedLocation.latitude,
                                          s.completedLocation.longitude,
                                          false
                                        )}
                                      ></i>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>{s.totalDistance ? (s.totalDistance/1000).toFixed(2)+" KM" : "-"}</td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            {this.state.prevpage != "#" && (
                              <Pagination.First
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.prevpage
                                )}
                                disabled={this.state.prevdisabled}
                              />
                            )}
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            {this.state.nextpage != "#" && (
                              <Pagination.Last
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.nextpage
                                )}
                                disabled={this.state.nextdisabled}
                              />
                            )}
                          </Pagination>
                        </div>
                      )}

                      <Modal
                        show={this.state.locationmodal}
                        onHide={() => this.setState({ locationmodal: true })}
                      >
                        <Modal.Header>
                          <Modal.Title>
                            Rider{" "}
                            {this.state.isDispatch ? "Dispatch" : "Completed"}{" "}
                            Location(
                            {this.state.currentLocation
                              ? `${this.state.currentLocation.lati}, ${this.state.currentLocation.long} `
                              : ""}
                            )
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Row>
                            <Col md={15}>
                              <div style={{ height: "260px" }}>
                                {this.state.locationdetails.length != 0 ? (
                                  <Map
                                    className="form-control"
                                    style={{ width: "100%" }}
                                    initialCenter={{
                                      lat: this.state.finallat,
                                      lng: this.state.finallng,
                                    }}
                                    bounds={this.state.bounds_data}
                                    google={this.props.google}
                                  >
                                    {this.state.finallat != 0 &&
                                    this.state.finallng != 0 ? (
                                      <Marker
                                        position={{
                                          lat: this.state.finallat,
                                          lng: this.state.finallng,
                                        }}
                                        name={"Sri Lanka"}
                                      />
                                    ) : (
                                      <Marker
                                        position={{ lat: "", lng: "" }}
                                        name={"Sri Lanka"}
                                      />
                                    )}

                                    <InfoWindow
                                      onClose={this.onInfoWindowClose}
                                    >
                                      <div>
                                        {/* <h1>{this.state.selectedPlace.name}</h1> */}
                                      </div>
                                    </InfoWindow>
                                  </Map>
                                ) : (
                                  <h4>Rider Location Not Found </h4>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            bsStyle="danger"
                            onClick={this.closelocationmodal.bind(this)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDYcP1T9HnFmllB0f_lMixg9EwNdkYCenE",
})(RiderDistance);
